import { Members } from "../../../types"
import { WaterlineInventoryResponse, WaterlineItem, WaterlineTestResult } from "../../practice/waterline/types"

export type TestResult = {
  status: number,
  message: string,
  complianceInterval: string,
  testDate?: string,
}

export type WaterlineCalendarRow = {
  practiceName: string,
  practiceCity: string,
  practiceState: string,
  customerNumber: string,
  members: Members[],
  compliance: {
    totalStatus: number,
  },
  testResults: TestResult[],
  testAlerts: WaterlineTestResult[],
}

export type WaterlineChild = {
  name: string,
  doctor_name: string,
  status: number,
  customer_number: string,
  created_date: string,
  waterline_last_test_date: string,
  waterline_num_active_items: number,
  waterline_compliance_interval: string,
  street: string,
  city: string,
  state: string,
  zip: string,
  phone: string,
  ot_last_connection_date: string,
  inactive: boolean,
  parent_customer_number: string,
  bio_compliance_status: number,
  bio_compliance_message: string,
  members: Members[],
  waterline_test_results?: WaterlineTestResult[],
  inventory?: WaterlineInventoryResponse[],
}

export type CorpWaterlineInventoryResponse = {
  practices: WaterlineChild[]
}

export type WaterlineCustomer = {
  children: WaterlineChild[]
}

export interface WaterlineInventoryItem extends WaterlineItem {
  childCustomerName: string,
}

export type FilterOption = {
  label: string,
  value: string,
}

export enum ComplianceStatus {
  green = 1,
  yellow = 2,
  red = 3,
  gray = 4,
}

export enum TestCompliance {
  passedTest = 'Test passed',
  failedTest = 'Failed test',
  passedRetest = 'Retest passed',
  failedRetest = 'Failed retest',
  missedTest = 'Missed test',
  inactive = 'Inactive',
  invalidTest = 'Invalid test',
}
